import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswPartnerResourcesState {
}

export default {
  state : {},
  actions: {
    getClaims(context: ActionContext<MswPartnerResourcesState, RootStoreState>) { // tslint:disable-line
      const url = 'claims/get-claims';
      return ApiServiceWrapper.get(url);
    },
    unClaim(context: ActionContext<MswPartnerResourcesState, RootStoreState>, payload:any) {
      context.commit('startLoading', null, { root: true });
      const url = 'claims/unclaim';
      return ApiServiceWrapper.post(url, payload);
    },
    addClaim(context: ActionContext<MswPartnerResourcesState, RootStoreState>, payload:any) {
      context.commit('startLoading', null, { root: true });
      const url = 'claims/add-claims';
      return ApiServiceWrapper.post(url, payload);
    },
  },
  namespaced: true,
} as Module<MswPartnerResourcesState, RootStoreState>;
